var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonePrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 426.667 426.667"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c8542"
    },
    d: "M173.118,320c-3.802,0-7.117-1.916-8.841-4.723c-0.077-0.107-0.115-0.218-0.201-0.324 c-11.191-19.861-22.959-54.583-22.959-101.619c0-47.04,11.759-81.758,22.959-101.615c0.085-0.111,0.124-0.218,0.201-0.324 c1.724-2.82,5.043-4.727,8.841-4.727V0C114.208,0,66.451,95.509,66.451,213.333c0,117.815,47.757,213.333,106.667,213.333V320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c8542"
    },
    d: "M237.118,12.8c0-3.277-1.25-6.554-3.75-9.05c-2.5-2.5-5.773-3.75-9.05-3.75h-38.4v106.667h38.4 c3.277,0,6.549-1.25,9.05-3.75c2.5-2.5,3.75-5.777,3.75-9.05V12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c8542"
    },
    d: "M237.118,332.8c0-3.277-1.25-6.554-3.75-9.05c-2.5-2.5-5.773-3.75-9.05-3.75h-38.4v106.667h38.4 c3.277,0,6.549-1.25,9.05-3.75c2.5-2.5,3.75-5.777,3.75-9.05V332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c8542"
    },
    d: "M253.118,253.338l-16-16.004c6.409-6.409,9.941-14.933,9.941-24s-3.533-17.591-9.941-24.009l16-16 c10.684,10.688,16.567,24.892,16.567,40.009C269.685,228.442,263.802,242.65,253.118,253.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c8542"
    },
    d: "M285.092,285.316l-16-16c14.985-14.985,23.223-34.867,23.223-55.983 c0-21.12-8.243-40.998-23.223-55.983l16-16.004c19.26,19.26,29.858,44.821,29.858,71.987 C314.95,240.491,304.352,266.057,285.092,285.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c8542"
    },
    d: "M317.084,317.308l-16-16.009c23.535-23.535,36.501-54.775,36.501-87.966 s-12.966-64.439-36.501-87.974l16-16.004c27.819,27.814,43.132,64.738,43.132,103.979 C360.22,252.565,344.902,289.498,317.084,317.308z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePrimary);
export default __webpack_public_path__ + "static/media/phone-primary.6a91176e995dbbb11a7579e13892f43f.svg";
export { ForwardRef as ReactComponent };